import { ReactNode } from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import { Container, Content } from './styles';
import { useAnuidade } from '../../hooks/anuidade';

interface Props {
  children: ReactNode;
}

function Main({ children }: Props) {
  const { anoAnuidade } = useAnuidade();
  return (
    <Container>
      <Header title={`Anuidade de ${anoAnuidade}`} />
      <Content className="container">{children}</Content>
      <Footer />
    </Container>
  );
}

export default Main;
